<div class="mb-2" [ngSwitch]="status" >
  <div class="cit2-alert alert-danger d-flex flex-column" role="alert" *ngSwitchCase="'failure'">
    <div class="content">
      <div class="icon">
        <span aria-hidden="true" class="icon-ui-caution"></span>
      </div>
      <div class="text">
        <div class="gb-body1 heavy">
          <p [translate]="'locateDealer_makeMyPreferred_error'"></p>
        </div>
      </div>
    </div>
  </div>

  <div class="cit2-alert alert-success d-flex flex-column" role="alert" *ngSwitchCase="'success'">
    <div class="content">
      <div class="icon">
        <span aria-hidden="true" class="icon-ui-checkcircle"></span>
      </div>
      <div class="text">
        <div class="gb-body1">
          <p [translate]="'locateDealer_dealerUpdatedAlert'"></p>
        </div>
      </div>
    </div>
  </div>
</div>

